import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import CustomerDetails from '../../main/customers/editDetailsCustomer/editDetailsCustomer';
import {
  updateOwnerCustomer,
  deleteOwnerCustomer,
  getOwnerCustomer,
  getOwnerCustomerRewardCounter,
  changeOwnerCustomerBlockStatus,
} from '../customers/actions';
import { canChangeCustomerBlockStatus, isCustomerBlockedFromBooking } from '../customers/customerForm/helpers';
import { USER_TYPES } from '../../auth/constants';

const ShopUserEditCustomerWrapper = ({
  params: { customerId },
  updateCustomer,
  shop,
  shopBrand,
  deleteCustomer,
  getCustomer,
  getRewardCounter,
}) => {
  const save = (id, data) => updateCustomer(shop, 'shop', id, data);
  const deleteFunc = id => deleteCustomer(shop, 'shop', id);
  const get = id => getCustomer(shop, 'shop', id);
  const getReward = id => getRewardCounter(shop, 'shop', id);
  const blockCustomer = id => changeOwnerCustomerBlockStatus(shop, 'shop', id, 'block');
  const unBlockCustomer = id => changeOwnerCustomerBlockStatus(shop, 'shop', id, 'unblock');
  const getIsBlocked = customer => isCustomerBlockedFromBooking({
    userKind: USER_TYPES.shop,
    customer,
    shopId: shop,
    brandId: shopBrand.id,
  });
  const getCanChangeCustomerBlockedStatus = customer => canChangeCustomerBlockStatus({
    userKind: USER_TYPES.shop,
    customer,
    shopId: shop,
    brandId: shopBrand.id,
  });

  return (
    <CustomerDetails
      redirectUrl="/customers"
      customerId={customerId}
      modifyCustomer={save}
      deleteCustomer={deleteFunc}
      getCustomer={get}
      getRewardCounter={getReward}
      blockCustomer={blockCustomer}
      unBlockCustomer={unBlockCustomer}
      getIsBlocked={getIsBlocked}
      getCanChangeCustomerBlockedStatus={getCanChangeCustomerBlockedStatus}
    />
  );
};

ShopUserEditCustomerWrapper.propTypes = {
  params: PropTypes.object.isRequired,
  shop: PropTypes.string.isRequired,
  shopBrand: PropTypes.string.isRequired,
  updateCustomer: PropTypes.func.isRequired,
  deleteCustomer: PropTypes.func.isRequired,
  getCustomer: PropTypes.func.isRequired,
  getRewardCounter: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  shop: state.auth.shop,
  shopBrand: state.auth.shopBrand,
});

const mapDispatchToProps = {
  updateCustomer: updateOwnerCustomer,
  deleteCustomer: deleteOwnerCustomer,
  getCustomer: getOwnerCustomer,
  getRewardCounter: getOwnerCustomerRewardCounter,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShopUserEditCustomerWrapper);
